import React from 'react'
import { REACT_APP_ZONE_SUFFIX } from '../apollo/apollo-client'
import styles from '../styles/Reviews.module.scss'

interface FooterProps {
  stepIsMood: boolean
}

export const Footer: React.FC<FooterProps> = ({ stepIsMood }) => {

  return (
    <footer className={styles.footer}>
      Powered by <br/>
      <div><img src="/logo.svg" alt="Logo" /></div>
      <div className={!stepIsMood ? styles.hide_privacy : ''}>
        By proceeding you accept our
        <a target="_blank"
          href={`https://${REACT_APP_ZONE_SUFFIX?.substr(1)}/app-privacy`}
          className={styles.footer_link}
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  )
}